import { TNotificationFieldsFragment } from 'generated/graphql';
import { PATIENTS_VIEW_ROUTE } from 'routes/constants';

export const buildNotificationUrl = ({
  exam,
  type,
  _id,
}: TNotificationFieldsFragment) => {
  if (!exam?._id || !type) {
    return;
  }

  const validationTypes = [
    'ready_to_validate',
    /** @deprecated This type has been deprecated */
    'exam',
  ];

  if (validationTypes.includes(type)) {
    return `/app/validation/${exam._id.toString()}/${_id.toString()}`;
  }

  if (type === 'exam_report_ready' && exam?.patient) {
    return `${PATIENTS_VIEW_ROUTE}${exam.patient._id.toString()}/exams/${exam._id.toString()}`;
  }
};
